export default __webpack_public_path__ + "images/b03c8888f0897be7f548958cf53daa20-medical.webp";